module.exports = __webpack_public_path__ + "static/media/Proyecto.b4fd4250.svg";